module.exports = __webpack_public_path__ + "assets/img/f452941028a659d9e14cb226f7efdbfc.svg";